import axios from 'axios';
import { call } from 'redux-saga/effects';
import { getTokenHeaders as tokenHeader } from '../helpers/api.helper';
import { GET_NOTIFICATION_CATEGORIES_ENDPOINT, UPDATE_PROFILE_NOTIFICATION_SETTINGS_ENDPOINT, GET_USER_DETAILS_ENDPOINT, UPDATE_FAVORITE_GENRES_ENDPOINT, UPDATE_USER_DETAILS_ENDPOINT } from '../config/apiEndpoints';

export function* getNotificationCategories(payload) {
    const header = tokenHeader();
    return yield call(axios.get, GET_NOTIFICATION_CATEGORIES_ENDPOINT, header);
}

export function* updateProfileNotificationSettings(payload){
    const header = tokenHeader();
    return yield call(axios.post, UPDATE_PROFILE_NOTIFICATION_SETTINGS_ENDPOINT, payload, header);
}

export function* getUserProfile(payload){
    const header = tokenHeader();
    const url = GET_USER_DETAILS_ENDPOINT + localStorage.getItem("user_id") + '?_format=api_json';
    return yield call(axios.get, url, header);
}

export function* updateFavoriteGenres(payload){
    const header = tokenHeader();
    return yield call(axios.post, UPDATE_FAVORITE_GENRES_ENDPOINT, payload, header);
}

export function* updateUserDetails(payload){
    const header = tokenHeader();
    return yield call(axios.post, UPDATE_USER_DETAILS_ENDPOINT, payload, header);
}


// WEBPACK FOOTER //
// ./src/SHARED/api/editprofile.api.js